import {
  contactConfiguration,
  cities,
  DEFAULT_COUNTRY
} from './contactConfiguration';

const getCities = () => Object.keys(cities);
const getKeysFromSet = set => Object.keys(set);
const getContryFromCity = city =>
  cities[city] ? cities[city].region : DEFAULT_COUNTRY;

const getDataFromCountrySet = (set, country) =>
  getKeysFromSet(set).includes(country) ? set[country] : set[DEFAULT_COUNTRY];

const getLandlordContactDataByCountry = country =>
  getDataFromCountrySet(contactConfiguration.landlords, country);

const getLandlordContactDataByCity = city =>
  getLandlordContactDataByCountry(getContryFromCity(city));

const getTenantContactDataByCountry = country =>
  getDataFromCountrySet(contactConfiguration.tenants, country);

const getTenantContactDataByCity = city =>
  getTenantContactDataByCountry(getContryFromCity(city));

const getPartnershipContactData = () => contactConfiguration.partnerships;

const getOtherContactData = () => contactConfiguration.other;

const getCountryByCity = city => (cities[city] ? cities[city].country : '');

export default {
  getCities,
  getCountryByCity,
  getTenantContactDataByCity,
  getLandlordContactDataByCity,
  getPartnershipContactData,
  getOtherContactData
};
